import { StatusBox } from "./StatusBox";

interface PlaygroundSectionProps {
  playgroundYn: "Y" | "N" | null;
}

export const PlaygroundSection = ({
  playgroundYn,
}: PlaygroundSectionProps) => {
  return (
    <div className="p-4 bg-white rounded-xl shadow-sm">
      <div className="flex gap-2 items-center mb-3">
        <svg
          className="w-5 h-5 text-gray-600"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"
          />
        </svg>
        <h3 className="text-[17px] font-semibold text-gray-800">실외 운동장</h3>
      </div>
      <div className="flex gap-2">
        <StatusBox title="있어요" isActive={playgroundYn === "Y"} />
        <StatusBox title="없어요" isActive={playgroundYn === "N"} />
      </div>
    </div>
  );
};

